module.exports = __webpack_public_path__ + "static/media/GAIL.61a68a8f.txt";